import React from "react";
import "./styles.scss"
import ESGChatMain from "../esg-chat/esg-chat";

const InvestorResearchMain = () => {
    return (
        <div className="investor-research-main">
            <ESGChatMain
                searchType="Investor"
                showDisclosuresSection
            />
        </div>
    )
}

export default InvestorResearchMain